var autosize = {

    /*
     * usage : autosize.resize(textarea)
     * return -
     */
    resize: (element) => {
        if (!element || element.tagName !== "TEXTAREA") {
            return;
        }

        const style  = window.getComputedStyle(element);
        const border = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);

        element.style.height = "auto";
        // scrollHeight is the content box, border-box sizing needs the borders back.
        element.style.height = `${element.scrollHeight + border}px`;
    },

    /*
     * usage : autosize.all()
     * return -
     */
    all: () => {
        document.querySelectorAll("textarea.js-autosize:not([data-autosize])").forEach((element) => {
            element.setAttribute("data-autosize", "1");
            autosize.resize(element);
        });
    },

    /*
     * usage : autosize.init()
     * return -
     */
    init: () => {
        // Blazor owns the DOM, so listen on the document instead of binding to
        // the textareas themselves.
        helper.event(document, 'input', (e) => {
            if (e.target.classList && e.target.classList.contains("js-autosize")) {
                autosize.resize(e.target);
            }
        });

        // Size textareas Blazor renders after page load.
        new MutationObserver(() => {
            window.requestAnimationFrame(autosize.all);
        }).observe(document.body, {childList: true, subtree: true});

        autosize.all();
    }
};
